import React, { createContext, useContext, useEffect } from "react";
import withAuth from "../../hocs/withAuth";
import withApp from "../../hocs/withApp";
import { Box, Grid2 } from "@mui/material";
import Header from "./components/header";
import Left from "./components/left";
import Right from "./components/right";
import { useDispatch } from "react-redux";
import { resetBooking } from "../../redux/reducers/booking.reducer";

type valueType = {};

const BookingContext = createContext<valueType>({
  route: null,
  setRoute: () => {},
});

const heights = {
  header: "60px",
};

function BookingPage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetBooking());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookingContext.Provider value={{}}>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100vh",
          height: "auto",
        }}
      >
        <Header height={heights.header} />
        <Box sx={{ px: 2, py: 1 }}>
          <Grid2 container spacing={1}>
            <Grid2 size={{ xs: 12, md: 3.5 }}>
              <Left headerHeight={heights.header} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 8.5 }}>
              <Right headerHeight={heights.header} />
            </Grid2>
          </Grid2>
        </Box>
      </Box>
    </BookingContext.Provider>
  );
}

export default withAuth(withApp(BookingPage));

export const useBookingContext = () => {
  const value = useContext(BookingContext);
  if (!value) throw new Error("Booking context is not");
  return value;
};
